<template>
  <div class="l_news" @click="tapAction" v-if="this.isImportant === '0'">
    <div class="l_news__grid">
      <div class="l_news__left">
        <img class="c_img" :src="this.image" />
      </div>
      <div class="l_news__right">
        <!-- <template v-if="(this.date1 - this.date2) / 86400000 < 7">
          <div class="l_news__new">
            <img class="c_img" :src="require('@/assets/img/new_mark.png')" />
          </div>
        </template> -->
        <h2 class="c_news__title">{{ this.title }}</h2>
        <div class="l_news__date">
          <span class="c_news__date"></span>
        </div>
        <div class="l_news__category">
          <!--<img
            class="c_img"
            :src="
              require('@/assets/img/label/' + this.categories[this.category])
            "
          />-->
        </div>
      </div>
    </div>
  </div>
  <div
    class="l_news banner"
    @click="tapAction"
    v-else-if="this.isImportant === '1'"
  >
    <img class="c_img" :src="this.image" />
    <div
      class="title"
      :class="{ premium: this.isPremium }"
      v-if="this.image.indexOf('_banner') >= 0"
    >
      {{ this.title }}
    </div>
  </div>
  <div
    class="l_news"
    style="
      position: relative;
      padding-bottom: 56.25%;
      height: 0;
      overflow: hidden;
    "
    @click="tapAction"
    v-else-if="this.isImportant === '3'"
  >
    <iframe
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
      width="560"
      height="315"
      :src="this.youtubeurl"
      frameborder="0"
      allow="autoplay; encrypted-media"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'NewsPanel',
  props: {
    url: { type: String, default: '' },
    image: { type: String, default: '' },
    title: { type: String, default: '' },
    date: { type: String, default: '' },
    category: { type: String, default: '' },
    isImportant: { type: String, required: true },
    kind: { type: Number, required: 0 },
    youtubeId: { type: String, default: '' },
    isPremium: { type: Boolean, required: 0 }
  },
  data: function () {
    return {
      categories: {
        0: 'info.svg',
        1: 'info.svg',
        2: 'campaign.svg',
        3: 'menu.svg',
        4: 'shop.svg',
        5: 'only-you.svg',
        6: 'tips.svg',
        12: 'info.svg',
        15: 'info.svg'
      },
      dateStr: ''
    }
  },
  created: function () {
    this.dateStr = this.date.split(' ')[0].split('-').join('/')
    this.date1 = new Date(Date.now())
    this.date2 = new Date(this.dateStr)
    this.youtubeurl = `https://www.youtube.com/embed/${this.youtubeId}?playsinline=1`
  },
  methods: {
    tapAction() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped lang="scss">
.l_news {
  width: 100%;
  border-radius: 10px;
  background-color: white;
  overflow: hidden;

  &.banner {
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    /* display: flex;
    justify-content: center; */
    .container {
      width: 100%;
      position: absolute;

      img {
        width: 100%;
        height: 100%;
      }
    }
    .title {
      text-align: center;
      position: absolute;
      top: 60%;
      width: 100%;
      font-size: 5vw;
      font-weight: bold;
      color: #66160E;
      padding: 0 20px;
      &.premium {
        color: #ffffff;
      }
    }
  }
}

.l_news + .l_news {
  margin-top: 10px;
}

.l_news__grid {
  display: flex;
}

.l_news__left {
  flex: 0 0 170px;
  width: 170px;
  height: 110px;
  overflow: hidden;
}

.l_news__right {
  flex: 1 1 auto;
  padding: 10px;
  position: relative;
}

/* title  */
.c_news__title {
  font-family: 'HiraKakuPro-W6';
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #66160E;
  margin: 10px 10px 0px;
  text-align: left;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  margin: 0;
}

/* date */
.l_news__date {
  position: absolute;
  bottom: 5px;
  left: 10px;
}

.c_news__date {
  text-align: left;
  position: absolute;
  bottom: 0px;
  left: 0px;
  font-family: 'HiraKakuPro-W3';
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #999999;
}

/* カテゴリ */

.l_news__category {
  width: 64px;
  height: 20px;
  position: absolute;
  bottom: 6px;
  right: 10px;
}

.l_news__new {
  width: 55px;
  height: 20px;
  margin: 0px 0px 5px;
  top: 0px;
  left: 0px;
}

.c_img {
  max-width: 100%;
  vertical-align: bottom;
  width: 100%;
}

@media only screen and (max-width: 320px) {
  .l_news__left {
    flex: 0 0 130px;
  }
}
</style>
